import { Routes } from '@angular/router';
import { ProdGuard } from '@app/core/guard/prod.guard';
import { RightGuard } from '@app/core/guard/right.guard';
import { Shell } from '@app/shell/shell.service';
import { RightsConst } from '@pezi/entities';

export const WARTUNGSDIENST_PREFIX = 'services';

export const APP_ROUTES: Routes = [
  {
    path:         'login',
    loadChildren: () => import('./modules/common/login/login-routing.module').then(m => m.LOGIN_ROUTES)
  },
  Shell.childRoutes([
    {
      path:         '',
      loadChildren: () => import('./modules/home/home-routing.module').then(m => m.HOME_ROUTES)
    },
    {
      path:         'contact-overview',
      loadChildren: () => import('./modules/common/contact-overview/contact-overview-routing.module').then(m => m.CONTACTOVERVIEW_ROUTES),
      data:         {'right': RightsConst.PZ_KONTAKT},
      canMatch:     [RightGuard]
    },
    {
      path:         'form-demo',
      canActivate:  [ProdGuard],
      loadChildren: () => import('./modules/demo/form-demo/form-demo-routing.module').then(m => m.FORMDEMO_ROUTES)
    },
    {
      path: 'person/' + WARTUNGSDIENST_PREFIX,
      loadChildren: () => import('./modules/wartungsdienste/person/person-wartungsdienste-routing.module').then(m => m.PERSONWARTUNGSDIENST_ROUTES),
      data:         {'right': RightsConst.PZ_WARTDIENST},
      canMatch:     [RightGuard]
    },
    {
      path: 'maklerperson/' + WARTUNGSDIENST_PREFIX,
      loadChildren: () => import('./modules/wartungsdienste/maklerperson/maklerperson-wartungsdienste-routing.module').then(m => m.MAKLERPERSONWARTUNGSDIENSTE_ROUTES),
      data:         {'right': RightsConst.PZ_MAKLER}
    },
    {
      path: 'maklerpolizze/' + WARTUNGSDIENST_PREFIX,
      loadChildren: () => import('./modules/wartungsdienste/maklerpolice/maklerpolice-wartungsdienste-routing.module').then(m => m.MAKLERPOLICEWARTUNGSDIENSTE_ROUTES),
      data:         {'right': RightsConst.PZ_MAKLER}
    },
    {
      path: 'police/' + WARTUNGSDIENST_PREFIX,
      loadChildren: () => import('./modules/wartungsdienste/police/police-wartungsdienste-routing.module').then(m => m.POLICEWARTUNGSDIENSTE_ROUTES),
      data:         {'right': RightsConst.PZ_WARTDIENST},
      canMatch:     [RightGuard]
    },
    {
      path:         'settings',
      loadChildren: () => import('./modules/common/settings/settings-routing.module').then(m => m.SETTINGS_ROUTES)
    },
    {
      path:         'todo-overview',
      loadChildren: () => import('./modules/common/todo/todo-overview/todo-overview-routing.module').then(m => m.TODOOVERVIEW_ROUTES)
    },
    {
      path:         'todo-detail',
      loadChildren: () => import('./modules/common/todo/todo-detail/todo-detail-routing.module').then(m => m.TODODETAIL_ROUTES)
    },
    {
      path:         'benutzer',
      loadChildren: () => import('./modules/admin/admin-routing.module').then(m => m.ADMINROUTES),
      data:         {'right': RightsConst.PZ_ADMIN},
      canMatch:     [RightGuard]
    },
    {
      path:         'partneradmin',
      loadChildren: () => import('./modules/partner-admin/partner-admin-routing.module').then(m => m.PARTNERADMIN_ROUTES),
      data:         {
        'right': [
          RightsConst.PZ_PARTNERADMIN,
          RightsConst.PZ_PARTNERADMIN_READ
        ]
      },
      canMatch:     [RightGuard]
    },
    {
      path:         'maklerpartneradmin',
      loadChildren: () => import('./modules/makler-partner-admin/makler-partner-admin-routing.module').then(m => m.MAKLERPARTNERADMIN_ROUTES),
      data:         {'right': RightsConst.PZ_MAKLER_USERADMIN},
      canMatch:     [RightGuard]
    },
    {
      path:         'person',
      loadChildren: () => import('./modules/bestandsabfrage/person/person-routing.module').then(m => m.PERSON_ROUTES),
      data:         {'right': RightsConst.PZ_PERSON},
      canMatch:     [RightGuard]
    },
    {
      path:         'polizze',
      loadChildren: () => import('./modules/bestandsabfrage/police/police-routing.module').then(m => m.POLICE_ROUTES),
      data:         {'right': RightsConst.PZ_POLIZZE},
      canMatch:     [RightGuard]
    },
    {
      path:         'vertreter',
      loadChildren: () => import('./modules/bestandsabfrage/vertreter/vertreter-routing.module').then(m => m.VERTRETER_ROUTES),
      data:         {'right': RightsConst.PZ_VERTRETER},
      canMatch:     [RightGuard]
    },
    {
      path:         'fahrzeug',
      loadChildren: () => import('./modules/bestandsabfrage/fahrzeug/fahrzeug-routing.module').then(m => m.FAHRZEUG_ROUTES),
      data:         {'right': RightsConst.PZ_FAHRZEUG},
      canMatch:     [RightGuard]
    },
    {
      path:         'schaden',
      loadChildren: () => import('./modules/bestandsabfrage/schaden/schaden-routing.module').then(m => m.SCHADEN_ROUTES),
      data:         {'right': RightsConst.PZ_SCHADEN},
      canMatch:     [RightGuard]
    },
    {
      path:         'haushalt',
      loadChildren: () => import('./modules/bestandsabfrage/haushalt/haushalt-routing.module').then(m => m.HAUSHALT_ROUTES),
      data:         {'right': RightsConst.PZ_HAUSHALT},
      canMatch:     [RightGuard]
    },
    {
      path:         'gebaeude',
      loadChildren: () => import('./modules/bestandsabfrage/gebaeude/gebaeude-routing.module').then(m => m.GEBAEUDE_ROUTES),
      data:         {'right': RightsConst.PZ_GEBAEUDE},
      canMatch:     [RightGuard]
    },
    {
      path:         'hotline',
      loadChildren: () => import('./modules/bestandsabfrage/hotline/hotline-routing.module').then(m => m.HOTLINE_ROUTES),
      data:         {'right': RightsConst.PZ_HOTLINE},
      canMatch:     [RightGuard]
    },
    {
      path:         'vsb',
      loadChildren: () => import('./modules/bestandsabfrage/vsb/vsb-routing.module').then(m => m.VSB_ROUTES),
      data:         {'right': RightsConst.PZ_VSB},
      canMatch:     [RightGuard]
    },
    {
      path:         'betreuer',
      loadChildren: () => import('./modules/bestandsabfrage/betreuer/betreuer-routing.module').then(m => m.BETREUER_ROUTES),
      data:         {'right': RightsConst.PZ_BETREUER},
      canMatch:     [RightGuard]
    },
    {
      path:         'analyse',
      loadChildren: () => import('./modules/bestandsabfrage/analyse/analyse-routing.module').then(m => m.ANAL_ROUTES)
    },
    {
      path:         'assistance',
      loadChildren: () => import('./modules/bestandsabfrage/assistance/assistance-routing.module').then(m => m.ASSISTANCE_ROUTES),
      data:         {'right': RightsConst.PZ_ASSISTANCE},
      canMatch:     [RightGuard]
    },
    {
      path:         'verbund',
      loadChildren: () => import('./modules/bestandsabfrage/verbund/verbund-routing.module').then(m => m.VERBUND_ROUTES),
      data:         {'right': RightsConst.PZ_VERBUND},
      canMatch:     [RightGuard]
    },
    {
      path:         'maklerknoten',
      loadChildren: () => import('./modules/bestandsabfrage/betreuerknoten/betreuerknoten-routing.module').then(m => m.BETREUERKNOTEN_ROUTES),
      data:         {'right': RightsConst.PZ_BETREUER_KNOTEN},
      canMatch:     [RightGuard]
    },
    {
      path:         'texte',
      loadChildren: () => import('./modules/bestandsabfrage/texte/texte-routing.module').then(m => m.TEXTE_ROUTES),
      data:         {'right': RightsConst.PZ_TEXTE},
      canMatch:     [RightGuard]
    },
    {
      path:         'familienpass',
      loadChildren: () => import('./modules/bestandsabfrage/familienpass/familienpass-routing.module').then(m => m.FAMILIENPASS_ROUTES),
      data:         {'right': RightsConst.PZ_FAMILIENPASS},
      canMatch:     [RightGuard]
    },
    {
      path:     'maklerfamilienpass',
      loadChildren: () => import('./modules/bestandsabfrage/maklerfamilienpass/maklerfamilienpass-routing.module').then(m => m.MAKLERFAMILIENPASS_ROUTES),
      data:     {'right': RightsConst.PZ_MAKLER_FAMILIENPASS},
      canMatch: [RightGuard]
    },
    {
      path:         'partner',
      loadChildren: () => import('./modules/bestandsabfrage/partner/partner-routing.module').then(m => m.PARTNER_ROUTES),
      data:         {'right': RightsConst.PZ_PARTNER},
      canMatch:     [RightGuard]
    },
    {
      path:         'schadenzahlungempf',
      loadChildren: () => import('./modules/bestandsabfrage/schadenzahlungempf/schadenzahlungempf-routing.module').then(m => m.SCHADENZAHLUNGEMPF_ROUTES),
      data:         {'right': RightsConst.PZ_SCHZAHLEMPF},
      canMatch:     [RightGuard]
    },
    {
      path:         'index',
      loadChildren: () => import('./modules/bestandsabfrage/index/index-routing.module').then(m => m.INDEX_ROUTES),
      data:         {'right': RightsConst.PZ_INDEX},
      canMatch:     [RightGuard]
    },
    {
      path:         'ungeklaertezahlungen',
      loadChildren: () => import('./modules/bestandsabfrage/ungeklaertezahlungen/ungeklaertezahlungen-routing.module').then(m => m.UNGEKLAERTEZAHLUNGEN_ROUTES),
      data:         {'right': RightsConst.PZ_ZAHLUNGEN},
      canMatch:     [RightGuard]
    },
    {
      path:         'schadenbeteiligter',
      loadChildren: () => import('./modules/bestandsabfrage/schadenbeteiligter/schadenbeteiligter-routing.module').then(m => m.SCHADENBETEILIGTER_ROUTES),
      data:         {'right': RightsConst.PZ_SCH_BETEIL},
      canMatch:     [RightGuard]
    },
    {
      path:         'bezugsberechtigter',
      loadChildren: () => import('./modules/bestandsabfrage/bezugsberechtigter/bezugsberechtigter-routing.module').then(m => m.BEZUGSBERECHTIGTER_ROUTES),
      data:         {'right': RightsConst.PZ_PERSON_BBR},
      canMatch:     [RightGuard]
    },
    {
      path:         'zulassung',
      loadChildren: () => import('./modules/bestandsabfrage/zulassung/zulassung-routing.module').then(m => m.ZULASSUNG_ROUTES),
      data:         {'right': RightsConst.PZ_ZULASSUNG},
      canMatch:     [RightGuard]
    },
    {
      path:         'banktag',
      loadChildren: () => import('./modules/bestandsabfrage/banktag/banktag-routing.module').then(m => m.BANKTAG_ROUTES),
      data:         {'right': RightsConst.PZ_ZAHLUNGEN},
      canMatch:     [RightGuard]
    },
    {
      path:         'svsterbetabelle',
      loadChildren: () => import('./modules/bestandsabfrage/svsterbetabelle/svsterbetabelle-routing.module').then(m => m.SVSTERBETABELLE_ROUTES),
      data:         {'right': RightsConst.PZ_SVS},
      canMatch:     [RightGuard]
    },
    {
      path:         'maklerperson',
      loadChildren: () => import('./modules/bestandsabfrage/maklerperson/maklerperson-routing.module').then(m => m.MAKLERPERSON_ROUTES),
      data:         {'right': RightsConst.PZ_MAKLER_PERSON},
      canMatch:     [RightGuard]
    },
    {
      path:         'maklerpolizze',
      loadChildren: () => import('./modules/bestandsabfrage/maklerpolizze/maklerpolizze-routing.module').then(m => m.MAKLERPOLIZZE_ROUTES),
      data:         {'right': RightsConst.PZ_MAKLER_POLIZZEN},
      canMatch:     [RightGuard]
    },
    {
      path:         'maklerschaden',
      loadChildren: () => import('./modules/bestandsabfrage/maklerschaden/maklerschaden-routing.module').then(m => m.MAKLERSCHADEN_ROUTES),
      data:         {'right': RightsConst.PZ_MAKLER_SCHADEN},
      canMatch:     [RightGuard]
    },
    {
      path:         'maklerbetreuer',
      loadChildren: () => import('./modules/bestandsabfrage/maklerbetreuer/maklerbetreuer-routing.module').then(m => m.MAKLERBETREUER_ROUTES),
      data:         {'right': RightsConst.PZ_MAKLER},
      canMatch:     [RightGuard]
    },
    {
      path:         'maklervertreter',
      loadChildren: () => import('./modules/bestandsabfrage/maklervertreter/maklervertreter-routing.module').then(m => m.MAKLERVERTRETER_ROUTES),
      data:         {'right': RightsConst.PZ_MAKLER_PROVKONTEN},
      canMatch:     [RightGuard]
    },
    {
      path:         'maklerkontakte',
      loadChildren: () => import('./modules/bestandsabfrage/maklerkontakte/maklerkontakte-routing.module').then(m => m.MAKLERKONTAKE_ROUTES),
      data:         {'right': RightsConst.PZ_MAKLER},
      canMatch:     [RightGuard]
    },
    {
      path:         'beitragszahler',
      loadChildren: () => import('./modules/bestandsabfrage/beitragszahler/beitragszahler-routing.module').then(m => m.BEITRAGSZAHLER_ROUTES),
      data:         {'right': RightsConst.PZ_BEZ},
      canMatch:     [RightGuard]
    },
    {
      path:         'versicherteperson',
      loadChildren: () => import('./modules/bestandsabfrage/versicherteperson/versicherteperson-routing.module').then(m => m.VERSICHERTEPERSON_ROUTES),
      data:         {'right': RightsConst.PZ_VSB},
      canMatch:     [RightGuard]
    },
    {
      path:         'nichtabgestattet',
      loadChildren: () => import('./modules/bestandsabfrage/nicht-abgestattet/nicht-abgestattet-routing.module').then(m => m.NICHTABGESTATTET_ROUTES),
      data:         {'right': RightsConst.PZ_ZAHLUNGEN},
      canMatch:     [RightGuard]
    },
    {
      path:         'genehmigung',
      loadChildren: () => import('./modules/bestandsabfrage/genehmigung/genehmigung-routing.module').then(m => m.GENEHMIGUNG_ROUTES),
      data:         {
        'right': [
          RightsConst.GENEHM_LOCKED,
          RightsConst.GENEHM_SONDER,
          RightsConst.UNLOCK_LOCKED_PER,
          RightsConst.UNLOCK_LOCKED_POL,
          RightsConst.UNLOCK_LOCKED_SCH,
          RightsConst.GENEHM_ANTRAG
        ]
      },
      canMatch:     [RightGuard]
    },
    {
      path:         'gehaltsumwandlung',
      loadChildren: () => import('./modules/bestandsabfrage/gehaltsumwandlung/gehaltsumwandlung-routing.module').then(m => m.GEHALTSUMWANDLUNG_ROUTES),
      data:         {'right': RightsConst.PZ_GEHALTSUMW},
      canMatch:     [RightGuard]
    },
    {
      path:         'archivadmin',
      loadChildren: () => import('./modules/admin/archiv-admin/archiv-admin-routing.module').then(m => m.ARCHIVADMIN_ROUTES),
      data:         {'right': RightsConst.PZ_ARCHIVADMIN},
      canMatch:     [RightGuard]
    },
    {
      path:         'motorsteuer',
      loadChildren: () => import('./modules/bestandsabfrage/motorsteuer/motorsteuer-routing.module').then(m => m.MOTORSTEUER_ROUTES),
      data:         {'right': RightsConst.PZ_MOTORSTEUER},
      canMatch:     [RightGuard]
    },
    {
      path:         'maklermotorsteuer',
      loadChildren: () => import('./modules/bestandsabfrage/maklermotorsteuer/maklermotorsteuer-routing.module').then(m => m.MAKLERMOTORSTEUER_ROUTES),
      data:         {'right': RightsConst.PZ_MAKLER},
      canMatch:     [RightGuard]
    },
    {
      path:         'maklerdocuments',
      loadChildren: () => import('./modules/bestandsabfrage/maklerdocuments/maklerdocuments-routing.module').then(m => m.MAKLERDOCUMENTS_ROUTES),
      data:         {'right': RightsConst.PZ_MAKLER},
      canMatch:     [RightGuard]
    },
    {
      path:         'maklerindex',
      loadChildren: () => import('./modules/bestandsabfrage/maklerindex/maklerindex-routing.module').then(m => m.MAKLERINDEX_ROUTES),
      data:         {'right': RightsConst.PZ_MAKLER},
      canMatch:     [RightGuard]
    },
    {
      path:         'maklervsb',
      loadChildren: () => import('./modules/bestandsabfrage/makler-vsb/makler-vsb-routing.module').then(m => m.MAKLERVSB_ROUTES),
      data:         {'right': RightsConst.PZ_MAKLER},
      canMatch:     [RightGuard]
    },
    {
      path:         'kostenstellen',
      loadChildren: () => import('./modules/admin/kostenstellen/kostenstellen-routing.module').then(m => m.KOSTENSTELLEN_ROUTES),
      data:         {'right': RightsConst.PZ_ADMIN},
      canMatch:     [RightGuard]
    },
    {
      path:         'maklermahnstand',
      loadChildren: () => import('./modules/bestandsabfrage/maklermahnstand/maklermahnstand-routing.module').then(m => m.MAKLERMAHNSTAND_ROUTES),
      data:         {'right': RightsConst.PZ_MAKLER},
      canMatch:     [RightGuard]
    },
    {
      path:         'news',
      loadChildren: () => import('./modules/common/news/news-routing.module').then(m => m.NEWS_ROUTES)
    },
    {
      path:         'maklertarife',
      loadChildren: () => import('./modules/bestandsabfrage/maklertarife/maklertarife-routing.module').then(m => m.MAKLERTARIFE_ROUTES)
    },
    {
      path:         'kundengeburtstag',
      loadChildren: () => import('./modules/bestandsabfrage/kundengeburtstag/kunden-geburtstag-routing.module').then(
        m => m.KUNDENGEBURTSTAG_ROUTES),
      data:         {'right': RightsConst.PZ_KND_GEBDAT},
      canMatch:     [RightGuard]
    },
    {
      path:         'kundenkarte',
      loadChildren: () => import('./modules/bestandsabfrage/kundenkarte/kundenkarte-routing.module').then(m => m.KUNDENKARTE_ROUTES),
      data:         {'right': RightsConst.PZ_KND_KARTE},
      canMatch:     [RightGuard]
    },
    {
      path:         'rkw',
      loadChildren: () => import('./modules/bestandsabfrage/rueckkaufswerte/rueckkaufswerte-routing.module').then(m => m.RUECKKAUFSWERTE_ROUTES),
      data:         {'right': RightsConst.PZ_RKW},
      canMatch:     [RightGuard]
    },
    {
      path:         'makleroffertprogramm',
      loadChildren: () => import('./modules/bestandsabfrage/makleroffertprogramm/makler-offertprogramm-routing.module').then(m => m.MAKLEROFFERTPROGRAMM_ROUTES),
      data:         {'right': RightsConst.PZ_MAKLER_OFFERT},
      canMatch:     [RightGuard]
    },
    {
      path:         'maklerexcel',
      loadChildren: () => import('./modules/bestandsabfrage/maklerrechner/maklerrechner-routing.module').then(m => m.MAKLERRECHNER_ROUTES),
      data:         {'right': RightsConst.PZ_MAKLER_EXCELRECHNER},
      canMatch:     [RightGuard]
    },
    {
      path:         'zahlungslimitadmin',
      loadChildren: () => import('./modules/admin/zahlungslimit-admin/zahlungslimit-admin-routing.module').then(m => m.ZAHLUNGSLIMITADMIN_ROUTES),
      data:         {'right': RightsConst.PZ_SCHZAHLADMIN},
      canMatch:     [RightGuard]
    },
    {
      path:         'cms',
      loadChildren: () => import('./modules/admin/cms/cms-routing.module').then(m => m.CMS_ROUTES),
      data:         {'right': RightsConst.PZ_MAKLERDOCADMIN}, // TODO RIGHT for CMS in Future
      canMatch:     [RightGuard]
    },
    {
      path:         'referate',
      loadChildren: () => import('./modules/bestandsabfrage/referate/referate-routing.module').then(m => m.REFERATE_ROUTES),
      data:         {'right': RightsConst.PZ_REFERATE},
      canMatch:     [RightGuard]
    },
    {
      path:         'mahnstand',
      loadChildren: () => import('./modules/bestandsabfrage/mahnstand/mahnstand-routing.module').then(m => m.MAHNSTAND_ROUTES),
      data:         {'right': RightsConst.PZ_MAHNSTAND},
      canMatch:     [RightGuard]
    },
    {
      path:         'datenschutz',
      loadChildren: () => import('./modules/bestandsabfrage/datenschutz/datenschutz-routing.module').then(m => m.DATENSCHUTZ_ROUTES),
      data:         {'right': RightsConst.PZ_DATENSCHUTZ},
      canMatch:     [RightGuard]
    },
    {
      path:         'kundendatenadmin',
      loadChildren: () => import('./modules/bestandsabfrage/kundendatenadmin/kundendatenadmin-routing.module').then(m => m.KUNDENDATENADMIN_ROUTES),
      data: {
        'right': [
          RightsConst.PZ_KNDA_ZUSA,
          RightsConst.PZ_KNDA_KUML
        ]
      },
      canMatch:     [RightGuard]
    },
    {
      path:         'intranetuser',
      loadChildren: () => import('./modules/admin/intranet-user/intranet-user-routing.module').then(m => m.INTRANETUSER_ROUTES),
      data:         {'right': RightsConst.PZ_ADMIN},
      canMatch:     [RightGuard]
    },
    {
      path:         'vsb-forward',
      loadChildren: () => import('./modules/bestandsabfrage/vsb-print-forwarding/vsb-print-forwarding-routing.module').then(m => m.VSBPRINTFORWARDING_ROUTES),
      data:         {'right': RightsConst.PZ_VERSBEST},
      canMatch:     [RightGuard]
    },
    {
      path:         'betreuerdatenadmin',
      loadChildren: () => import('./modules/admin/betreuerdaten-admin/betreuerdaten-admin-routing.module').then(m => m.BETREUERDATENADMIN_ROUTES),
      canMatch: [RightGuard],
      data:     {'right': RightsConst.PZ_BETDA}
    },
    {
      path:         'referatadmin',
      loadChildren: () => import('./modules/admin/referat-admin/referat-admin-routing.module').then(m => m.REFERATADMIN_ROUTES),
      canMatch:     [RightGuard],
      data:         {'right': RightsConst.PZ_REFERATADMIN}
    },
    {
      path:         'beratungsleitfaden',
      loadChildren: () => import('./modules/bestandsabfrage/beratungsleitfaden/beratungsleitfaden-routing.module').then(m => m.BERATUNGSLEITFADEN_ROUTES),
      data:         {'right': RightsConst.PZ_BERATUNGSLEITFADEN}
    }
  ]),
  // Fallback when no prior route is matched

  {
    path:       '**',
    redirectTo: '',
    pathMatch:  'full'
  }

];
